import { call, put, select, takeEvery } from 'redux-saga/effects';
import { failurePut, IFailurePutCall } from '../../app/failurePut';
import { getRequest, postRequest } from '../../app/request';
import parseAccountName from "../../utils/parseAccountName";
import { pushGtmEventAction } from "../GoogleTagManager/googleTagManagerActions";
import {
    checkBonusPromocodeFailure,
    checkBonusPromocodeSuccess,
    getNewLifeAccountsAction,
    getNewLifeAccountsFailure,
    getNewLifeAccountsSuccess,
    processInitPromocodeAction,
    setBonusPromocodeAction,
    setNewLifeRespawnFailure,
    setNewLifeRespawnSuccess
} from "./bonusesActions";
import {
    CHECK_BONUS_PROMOCODE_START,
    GET_NEW_LIFE_ACCOUNTS_START,
    PROCESS_INIT_PROMOCODE_START,
    PROMOCODE_NAMES,
    SET_NEW_LIFE_RESPAWN_START
} from "./bonusesConstants";
import { ICheckBonusPromocodePayload, INewLifeAccounts, ISetNewLifeRespawnSuccess } from './types/bonusesActions';
import { accountGetPortfolioAction } from "../Account/accountActions";
import { getActivePromocodes, getBonusPromocode } from "./bonusesSelectors";
import { isClientMobile } from "../../components/ClientInfo/ClientInfo";
import { openMobileSliderPageAction } from "../../mobileAppCore/mobileAppActions";
import Cookies from "universal-cookie";
import { MOBILE_SLIDER_PAGES_IDS } from "../../mobileAppCore/components/MobileSliderPages/mobileSliderPagesConstants";
import { openModalAction } from "../../app/appActions";
import { MODALS_NAME } from "../Modals/modalsConstants";
import _ from "lodash";
import { getAppFeatures } from "../../app/appSelectors";
import { FEATURES } from "../../app/appConstants";
import { referralSlice } from "../Referral/referralReducer";

const browserCookies = new Cookies();

export function* getNewLifeAccountsSaga() {
    try {
        const data: INewLifeAccounts = yield call(getRequest, '/user/bonus/new-life/list');
        yield put(getNewLifeAccountsSuccess(data));
    } catch (e: any) {
        yield call(failurePut, e, getNewLifeAccountsFailure);
    }
}

interface ISetNewLifeRespawnSaga {
    payload: {
        accountCode: string;
        email: string;
    }
}

export function* setNewLifeRespawnSaga({ payload }: ISetNewLifeRespawnSaga) {
    const features = yield select(getAppFeatures);
    const parsedAccount = parseAccountName(payload.accountCode);
    try {
        const data: ISetNewLifeRespawnSuccess = yield call(postRequest, `/user/bonus/new-life/${encodeURIComponent(payload.accountCode)}/respawn`, {
            email: payload.email,
        });
        yield put(getNewLifeAccountsAction());
        yield put(setNewLifeRespawnSuccess(data));
        yield put(pushGtmEventAction({
            event: 'success_respawn',
            module: 'RespawnPage',
            account_type: parsedAccount?.type,
        }));

        if (features[FEATURES.REFERRAL]) {
            yield put(referralSlice.actions.getReferralAction());
        }
    } catch (e: any) {
        yield put(pushGtmEventAction({
            event: 'errorConfirmEmail',
            module: 'RespawnPage',
            error: e.response?.data?.messageCode,
            account_type: parsedAccount?.type,
        }));
        yield call(failurePut, e, setNewLifeRespawnFailure);
    }
}

export function* checkBonusPromocodeSaga({ payload }: { payload: ICheckBonusPromocodePayload }) {
    try {
        const activePromocodes = yield select(getActivePromocodes);
        if (_.find(activePromocodes, { promocode: payload.promocode })) {
            yield put(setBonusPromocodeAction(payload.promocode));
        } else {
            const data = yield call(postRequest, '/user/promocode/check', {
                promocode: payload.promocode,
            });
            yield put(checkBonusPromocodeSuccess(data.promocode));
            yield put(setBonusPromocodeAction(payload.promocode));
            payload.onSuccessCallback && payload.onSuccessCallback(data);
        }
    } catch (e: any) {
        yield call<IFailurePutCall>(failurePut, e, checkBonusPromocodeFailure);
    }
    yield put(accountGetPortfolioAction());
}

export function* processInitPromocodeSaga({ payload: promocode }: ReturnType<typeof processInitPromocodeAction>) {
    if (browserCookies.get('coupon')) {
        browserCookies.remove('coupon', { path: '/' });
    }
    yield call(checkBonusPromocodeSaga, { payload: { promocode } });
    const currentActivePromocodes = yield select(getActivePromocodes);
    const selectedPromocode = yield select(getBonusPromocode);

    if (selectedPromocode && !_.find(currentActivePromocodes, { promocode: selectedPromocode })) {
        // обработать применение промокода
        switch (selectedPromocode) {
            case PROMOCODE_NAMES.HELLOJETVIX:
                if (isClientMobile) {
                    yield put(openMobileSliderPageAction(MOBILE_SLIDER_PAGES_IDS.PROMOCODE_HELLO_JETVIX));
                } else {
                    yield put(openModalAction(MODALS_NAME.PROMOCODE_HELLO_JETVIX));
                }
        }
    }
}

export function* bonusesSagas() {
    yield takeEvery(GET_NEW_LIFE_ACCOUNTS_START, getNewLifeAccountsSaga);
    // @ts-ignore
    yield takeEvery(SET_NEW_LIFE_RESPAWN_START, setNewLifeRespawnSaga);
    // @ts-ignore
    yield takeEvery(CHECK_BONUS_PROMOCODE_START, checkBonusPromocodeSaga);
    yield takeEvery(PROCESS_INIT_PROMOCODE_START, processInitPromocodeSaga);
}
